import {
  Grid,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";

export const AuditEventsTable = ({ data, loading, handleChangePage }) => {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>
            <b>Време на настанот</b>
          </TableCell>
          <TableCell>
            <b>Тип на настан</b>
          </TableCell>
          <TableCell>
            <b>Идентификатор на реф. објект</b>
          </TableCell>
          <TableCell>
            <b>Корисник</b>
          </TableCell>
          <TableCell>
            <b>Акција</b>
          </TableCell>
        </TableRow>
      </TableHead>
      {!loading &&
        data?.content?.map((log, index) => (
          <TableRow
            key={log.id}
            style={{
              backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
            }}
          >
            <TableCell>{log.timestamp}</TableCell>
            <TableCell>{log.eventType}</TableCell>
            <TableCell>{log.relId}</TableCell>
            <TableCell>{log.username}</TableCell>
            <TableCell>{log.action ?? "/"}</TableCell>
          </TableRow>
        ))}
      {!loading && data?.content?.length === 0 && (
        <TableRow>
          <TableCell colSpan={5} align="center">
            Не се пронајдени податоци.
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        <TableCell colSpan={5}>
          <TablePagination
            rowsPerPageOptions={[15]}
            component="div"
            count={data?.totalElements}
            rowsPerPage={data?.size}
            page={data?.number}
            onPageChange={handleChangePage}
          />
        </TableCell>
      </TableRow>
    </Table>
  );
};
